import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "./store";
import Routes from "./Routes";
import { initPerformanceMonitoring } from "./utils/performance";

function App() {
  useEffect(() => {
    // Inicializa monitoramento de performance
    initPerformanceMonitoring();
  }, []);

  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  );
}

export default App;
